var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../services/toastNotification", "../models/generateAndRespondTermConsentCommand"], function (require, exports, toastNotification_1, generateAndRespondTermConsentCommand_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    generateAndRespondTermConsentCommand_1 = __importDefault(generateAndRespondTermConsentCommand_1);
    var SelfServiceModal = (function () {
        function SelfServiceModal(routeId, selfServiceRequest, geoLocation, onCloseAfterResponse) {
            var _this = this;
            if (onCloseAfterResponse === void 0) { onCloseAfterResponse = null; }
            var _a;
            this.GetModal = function () { return document.getElementById(_this._id.modal); };
            this.GetLinkClose = function () { return document.getElementById(_this._id.close); };
            this.GetBtnSim = function () { return document.getElementById(_this._id.btnResposta.sim); };
            this.GetBtnNao = function () { return document.getElementById(_this._id.btnResposta.nao); };
            this.GetTxtEmail = function () { return document.getElementById(_this._id.txtEmail); };
            this.GetResult = function () { return document.getElementById(_this._id.resultMessage); };
            this.GetBtnClose = function () { return document.getElementById(_this._id.btnClose); };
            this.GetTxtConfirmMessage = function () { return document.getElementById(_this._id.txtConfirmMessage); };
            this.GetTextRefused1 = function () { return document.getElementById(_this._id.textRefused1); };
            this.GetTextRefused2 = function () { return document.getElementById(_this._id.textRefused2); };
            this.GetActivitiesDiv = function () { return document.getElementById(_this._id.activities); };
            this.GetActivitiesTable = function () { return document.getElementById(_this._id.activitiesTable); };
            this.GetForm = function () { return document.getElementById(_this._id.form); };
            this._id = {
                btnClose: 'btn-close-modal',
                btnResposta: {
                    sim: 'btn-sim',
                    nao: 'btn-nao'
                },
                close: 'selfservice-modal-close',
                form: 'selfservice-modal-form',
                modal: 'selfservice-modal',
                resultMessage: 'selfservice-modal-result',
                txtEmail: 'txt-email',
                txtConfirmMessage: 'msg-confimacao',
                textRefused1: 'paragraphRefused1',
                textRefused2: 'paragraphRefused2',
                activities: 'selfservice-modal-activities',
                activitiesTable: 'selfservice-modal-activities-table',
                termVersionId: '#txt-termVersionId'
            };
            this._isOpen = false;
            this._routeId = null;
            this._acceptTerm = null;
            this._protocol = null;
            this._birthDate = null;
            this._cpf = null;
            this._geoLocation = null;
            this._termActivityAnswers = [];
            this._onCloseAfterResponseCallback = null;
            this._toastMs = {
                validation: 5000,
                success: 10000,
                error: 10000
            };
            this._messages = {
                title: {
                    accept: 'Confirme o seu aceite',
                    reject: 'Confirme a recusa do termo'
                },
                success: {
                    accepted: 'Termo aceito com sucesso',
                    rejected: 'Termo recusado com sucesso'
                },
                err: {
                    respond: 'Ocorreu um erro inesperado ao gerar termo de consentimento, por favor tente novamente mais tarde'
                },
                validation: {
                    email: 'Por favor digite um e-mail válido'
                }
            };
            this._answeringTerm = false;
            this._routeId = routeId;
            this.AddEvents();
            this._onCloseAfterResponseCallback = onCloseAfterResponse;
            this._selfServiceRequest = selfServiceRequest;
            this._geoLocation = geoLocation ? JSON.stringify(geoLocation) : null;
            this._termActivityAnswers = (_a = this._termActivityAnswers) !== null && _a !== void 0 ? _a : [];
        }
        SelfServiceModal.prototype.Open = function (acceptTerm, protocol, cpf, birthDate, activities) {
            this.Reset();
            this._acceptTerm = acceptTerm;
            this._protocol = protocol;
            this._cpf = cpf;
            this._birthDate = birthDate;
            this.ToggleModal(true);
            this.ShowActivities(activities);
            this.SetConfirmMessage(acceptTerm);
            this._isOpen = true;
        };
        SelfServiceModal.prototype.Close = function (e) {
            if (e === void 0) { e = null; }
            if (e)
                e.preventDefault();
            this.ToggleModal(false);
            this._isOpen = false;
            this.Reset();
            if (this._onCloseAfterResponseCallback)
                this._onCloseAfterResponseCallback();
        };
        SelfServiceModal.prototype.SetToastTime = function (success, error, validation) {
            this._toastMs.success = success > 0 ? success : this._toastMs.success;
            this._toastMs.error = error > 0 ? error : this._toastMs.error;
            this._toastMs.validation = validation > 0 ? validation : this._toastMs.validation;
            return this;
        };
        SelfServiceModal.prototype.Reset = function () {
            this._acceptTerm = null;
            this._protocol = null;
            this._birthDate = null;
            this._cpf = null;
            this._termActivityAnswers = [];
            this.CleanEmail();
            this.SetInvalid(this.GetTxtEmail(), false);
            this.ShowResultMessage(false);
            this.ShowActivities(null);
            this.enableBtnSim();
            this.GetTermVersion().value = '0';
        };
        SelfServiceModal.prototype.AddEvents = function () {
            var _this = this;
            var _a, _b, _c, _d, _e;
            (_a = this.GetTxtEmail()) === null || _a === void 0 ? void 0 : _a.addEventListener('focusout', function () { return _this.ValidateEmailOnFocusOut(); });
            (_b = this.GetBtnSim()) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function (e) { return _this.AnswerTerm(e); });
            (_c = this.GetBtnNao()) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function (e) { return _this.Close(e); });
            (_d = this.GetLinkClose()) === null || _d === void 0 ? void 0 : _d.addEventListener('click', function (e) { return _this.Close(e); });
            (_e = this.GetBtnClose()) === null || _e === void 0 ? void 0 : _e.addEventListener('click', function (e) { return _this.Close(e); });
            document.addEventListener('keydown', function (e) { return _this.OnEscKeyDown(e); });
            document.addEventListener('keydown', function (e) { return _this.OnEnterKeyDown(e); });
        };
        SelfServiceModal.prototype.AnswerTerm = function (e) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var elements, disableElements, payload, res, message, message, paragraphRefused1, paragraphRefused2, e_1;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            elements = Array.from(document.getElementsByTagName('button'));
                            elements.push.apply(elements, Array.from(document.getElementsByTagName('input')));
                            disableElements = function (x) {
                                elements.forEach(function (elem) {
                                    elem.disabled = x;
                                });
                            };
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, 4, 5]);
                            e.preventDefault();
                            if (this._answeringTerm)
                                return [2];
                            this._answeringTerm = true;
                            disableElements(true);
                            payload = this.BuildPayload();
                            if (!payload)
                                return [2];
                            if (this.DoesUserWantsEmail() && !this.IsEmailValid()) {
                                this.ValidateEmail(false);
                                return [2];
                            }
                            return [4, this._selfServiceRequest.Respond(payload)];
                        case 2:
                            res = _e.sent();
                            if (res.success) {
                                message = (res.message != null && ((_b = (_a = res.message) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)
                                    ? res.message
                                    : payload.Accepted ? this._messages.success.accepted : this._messages.success.rejected;
                                toastNotification_1.ToastNotification.Success(message, this._toastMs.success);
                            }
                            else {
                                message = (res.message != null && ((_d = (_c = res.message) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0)
                                    ? res.message
                                    : this._messages.err.respond;
                                toastNotification_1.ToastNotification.Error(message, this._toastMs.error);
                            }
                            paragraphRefused1 = this.GetTextRefused1();
                            paragraphRefused2 = this.GetTextRefused2();
                            if (!payload.Accepted) {
                                paragraphRefused1 === null || paragraphRefused1 === void 0 ? void 0 : paragraphRefused1.classList.remove("hidden");
                                paragraphRefused2 === null || paragraphRefused2 === void 0 ? void 0 : paragraphRefused2.classList.remove("hidden");
                            }
                            else {
                                paragraphRefused1 === null || paragraphRefused1 === void 0 ? void 0 : paragraphRefused1.classList.add("hidden");
                                paragraphRefused2 === null || paragraphRefused2 === void 0 ? void 0 : paragraphRefused2.classList.add("hidden");
                            }
                            this.ShowResultMessage(true);
                            return [3, 5];
                        case 3:
                            e_1 = _e.sent();
                            toastNotification_1.ToastNotification.Error(e_1.message, this._toastMs.error);
                            return [3, 5];
                        case 4:
                            this._answeringTerm = false;
                            disableElements(false);
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        SelfServiceModal.prototype.BuildPayload = function () {
            if (this._routeId == null || !this._protocol || this._acceptTerm == null || !this._cpf || !this._birthDate)
                return null;
            var payload = new generateAndRespondTermConsentCommand_1.default(this._routeId, this._protocol, this._cpf, this._birthDate, this.GetEmail(), this._acceptTerm, this._geoLocation, this._termActivityAnswers, Number(this.GetTermVersion().value));
            return payload;
        };
        SelfServiceModal.prototype.SetConfirmMessage = function (accept) {
            var msg = this.GetTxtConfirmMessage();
            if (!msg)
                return;
            msg.innerText = accept ? this._messages.title.accept : this._messages.title.reject;
        };
        SelfServiceModal.prototype.ShowActivities = function (activities) {
            var _this = this;
            var _a, _b, _c, _d;
            var activitiesDiv = this.GetActivitiesDiv();
            var activitiesTable = this.GetActivitiesTable();
            var activitiesTableBody = activitiesTable === null || activitiesTable === void 0 ? void 0 : activitiesTable.querySelector('tbody');
            if (((_b = (_a = activities === null || activities === void 0 ? void 0 : activities.activities) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
                activitiesDiv === null || activitiesDiv === void 0 ? void 0 : activitiesDiv.classList.remove('hidden');
                activitiesTable === null || activitiesTable === void 0 ? void 0 : activitiesTable.classList.remove('hidden');
                activitiesTableBody.innerHTML = (_c = activities === null || activities === void 0 ? void 0 : activities.activities) === null || _c === void 0 ? void 0 : _c.map(function (a) { return "\n                <tr>\n                    <td class=\"w-11/12\" style=\"text-wrap: wrap;\">" + a.description + "</td>\n                    <td>\n                        <div class=\"w-full mb-4 md:mb-2 md:w-1/3 flex items-center\">\n                            <div class=\"relative inline-block w-full md:w-32 xl:w-32 mr-2 align-middle select-none transition duration-200 ease-in\">\n                                <input type=\"checkbox\" id=\"chk-aceito-" + a.id + "\" data-id=\"" + a.id + "\" class=\"chk-aceito toggle-checkbox-activity absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer\" />\n                                <label for=\"chk-aceito-" + a.id + "\" class=\"toggle-label-activity block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer\"></label>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n            "; }).join('');
                document.querySelectorAll('.chk-aceito').forEach(function (el) {
                    var _a;
                    el.addEventListener('change', function (e) { return _this.answerTermActivity(e); });
                    (_a = el.nextElementSibling) === null || _a === void 0 ? void 0 : _a.click();
                });
                this.GetTermVersion().value = String(activities === null || activities === void 0 ? void 0 : activities.termVersionId);
                (_d = document.querySelector('.tableScrollSmall')) === null || _d === void 0 ? void 0 : _d.scrollTo(0, 0);
            }
            else {
                activitiesDiv === null || activitiesDiv === void 0 ? void 0 : activitiesDiv.classList.add('hidden');
                activitiesTable === null || activitiesTable === void 0 ? void 0 : activitiesTable.classList.add('hidden');
                activitiesTableBody.innerHTML = '';
            }
        };
        SelfServiceModal.prototype.answerTermActivity = function (e) {
            var _a, _b;
            var targetElem = e.target;
            var activityId = Number(targetElem.dataset.id);
            if ((_a = this._termActivityAnswers) === null || _a === void 0 ? void 0 : _a.some(function (x) { return x.ActivityId == activityId; }))
                this._termActivityAnswers = __spreadArrays(this._termActivityAnswers.filter(function (x) { return x.ActivityId != activityId; }));
            (_b = this._termActivityAnswers) === null || _b === void 0 ? void 0 : _b.push({
                ActivityId: activityId,
                Answer: targetElem.checked,
                AnsweredAt: new Date().toISOString()
            });
            if (this._termActivityAnswers.some(function (x) { return x.Answer; }))
                this.enableBtnSim();
            else
                this.disableBtnSim();
        };
        SelfServiceModal.prototype.CleanEmail = function () {
            var email = this.GetTxtEmail();
            if (email)
                email.value = '';
        };
        SelfServiceModal.prototype.DoesUserWantsEmail = function () {
            var _a;
            return ((_a = this.GetTxtEmail()) === null || _a === void 0 ? void 0 : _a.value) ? true : false;
        };
        SelfServiceModal.prototype.GetEmail = function () {
            var _a, _b;
            var res = null;
            var sendEmail = this.DoesUserWantsEmail();
            if (!sendEmail)
                return res;
            res = (_b = (_a = this.GetTxtEmail()) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null;
            return res;
        };
        SelfServiceModal.prototype.IsEmailValid = function () {
            var regexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;
            var email = this.GetEmail();
            var valid = !!email && regexp.test(email);
            return valid;
        };
        SelfServiceModal.prototype.OnEscKeyDown = function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                this.Close(e);
            }
        };
        SelfServiceModal.prototype.OnEnterKeyDown = function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                var btnClose = this.GetBtnClose();
                if (!!btnClose && btnClose.disabled === false)
                    btnClose.click();
            }
        };
        SelfServiceModal.prototype.SetInvalid = function (elem, invalid) {
            var _a, _b, _c, _d;
            var invalidBorder = ['border-red-600'];
            var validBorder = ['border-gray-400'];
            if (!elem)
                return;
            if (invalid) {
                (_a = elem.classList).remove.apply(_a, validBorder);
                (_b = elem.classList).add.apply(_b, invalidBorder);
            }
            else {
                (_c = elem.classList).remove.apply(_c, invalidBorder);
                (_d = elem.classList).add.apply(_d, validBorder);
            }
        };
        SelfServiceModal.prototype.ShowResultMessage = function (show) {
            var _this = this;
            var _a, _b, _c, _d;
            var result = this.GetResult();
            var btnClose = this.GetBtnClose();
            if (!result || !btnClose)
                return;
            btnClose.disabled = !show;
            if (show) {
                (_a = this.GetForm()) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
                (_b = result.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
                result.classList.remove('hidden');
                setTimeout(function () {
                    _this.Close();
                }, 10000);
            }
            else {
                (_c = result.parentElement) === null || _c === void 0 ? void 0 : _c.classList.add('hidden');
                result.classList.add('hidden');
                (_d = this.GetForm()) === null || _d === void 0 ? void 0 : _d.classList.remove('hidden');
            }
        };
        SelfServiceModal.prototype.ToggleModal = function (show) {
            if (show === void 0) { show = null; }
            var toggleClass = 'hidden';
            var modal = this.GetModal();
            if (!modal)
                return;
            if (show == null) {
                if (!modal.classList.contains(toggleClass))
                    modal.classList.add(toggleClass);
                else
                    modal.classList.remove(toggleClass);
            }
            else {
                if (show)
                    modal.classList.remove(toggleClass);
                else
                    modal.classList.add(toggleClass);
            }
        };
        SelfServiceModal.prototype.ValidateEmail = function (valid) {
            if (valid === void 0) { valid = null; }
            var isInvalid = !(valid !== null && valid !== void 0 ? valid : this.IsEmailValid()) && this.DoesUserWantsEmail();
            if (isInvalid)
                toastNotification_1.ToastNotification.Alert(this._messages.validation.email);
            var email = this.GetTxtEmail();
            if (email)
                this.SetInvalid(email, isInvalid);
        };
        SelfServiceModal.prototype.ValidateEmailOnFocusOut = function () {
            var _this = this;
            var callback = function () {
                _this.ValidateEmail();
            };
            setTimeout(callback, 150);
        };
        SelfServiceModal.prototype.GetTermVersion = function () {
            return document.querySelector(this._id.termVersionId);
        };
        SelfServiceModal.prototype.disableBtnSim = function () {
            var btnSim = this.GetBtnSim();
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.setAttribute('disabled', 'disabled');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.classList.add('cursor-not-allowed');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.classList.remove('cursor-pointer', 'hover:bg-green-600');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.setAttribute('title', 'É necessário aceitar ao menos uma finalidade do termo de consentimento.');
        };
        SelfServiceModal.prototype.enableBtnSim = function () {
            var btnSim = this.GetBtnSim();
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.removeAttribute('disabled');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.classList.remove('cursor-not-allowed');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.classList.add('cursor-pointer', 'hover:bg-green-600');
            btnSim === null || btnSim === void 0 ? void 0 : btnSim.removeAttribute('title');
        };
        return SelfServiceModal;
    }());
    exports.default = SelfServiceModal;
});
